import styles from './support.module.scss';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton, Box, Link } from '@mui/material';
import { getCountry } from 'utils/country';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SupportIcon } from 'icons/life-buoy.svg';
import { ReactComponent as BookingIcon } from 'icons/book-open.svg';
import { supportConfig, getEmailByCountry } from 'config/supportConfig';
import { useTranslation } from 'react-i18next';
import { getFullPathOrHome } from 'utils/paths';

const boxStyle = {
  borderRadius: '4px',
  padding: '20px',
  background: '#eeeff0',
  marginBottom: '16px',
};

export default function Support() {
  const history = useHistory();
  const { t } = useTranslation();

  const onBackBtnClick = () => {
    history.push(getFullPathOrHome());
  };

  return (
    <div className={styles.container}>
      <div className={styles.column1}></div>
      <div className={styles.column2}>
        <div>
          <IconButton
            data-testid="BackBtn"
            className={styles.back_btn}
            onClick={onBackBtnClick}
            size="small">
            <ArrowBackIosIcon />
          </IconButton>
          <div className={styles.title}>{t('support.title')}</div>
          <div className={styles.description}>{t('support.description')}</div>
          <Box sx={boxStyle} component="div">
            <div className={styles.section_title}>
              <SupportIcon />
              {t('support.emailSupport')}
            </div>
            <div className={styles.section_description}>{t('support.emailDescription')}</div>
            <IconButton
              data-testid="FaqButton"
              className={styles.section_arrow}
              onClick={() => {
                window.location = `mailto:${getEmailByCountry(getCountry())}`;
              }}
              size="small">
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          <Box sx={boxStyle} component="div">
            <div className={styles.section_title}>
              <BookingIcon /> {t('support.learnMoreSupport')}
            </div>
            <div className={styles.section_description}>{t('support.learnMoreDescription')}</div>
            <Link href={supportConfig.sharepointUrl} rel="noopener noreferrer" target="_blank">
              <IconButton className={styles.section_arrow} size="small">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          </Box>
          <Box sx={boxStyle} component="div">
            <div className={styles.section_title}>
              <BookingIcon /> {t('support.brokerToolsSupport')}
            </div>
            <div className={styles.section_description}>{t('support.brokerToolsDescription')}</div>
            <Link
              href={supportConfig.brokerToolsSharepointUrl}
              rel="noopener noreferrer"
              target="_blank">
              <IconButton className={styles.section_arrow} size="small">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          </Box>
          <Box sx={boxStyle} component="div">
            <div className={styles.section_title}>
              <BookingIcon /> {t('support.emeaSupport')}
            </div>
            <div className={styles.section_description}>{t('support.emeaDescription')}</div>
            <Link
              href={supportConfig.emeaSharepointUrl}
              rel="noopener noreferrer"
              target="_blank">
              <IconButton className={styles.section_arrow} size="small">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          </Box>
          <Box sx={boxStyle} component="div">
            <div className={styles.section_title}>
              <BookingIcon /> {t('support.apacSupport')}
            </div>
            <div className={styles.section_description}>{t('support.apacDescription')}</div>
            <Link
              href={supportConfig.apacSharepointUrl}
              rel="noopener noreferrer"
              target="_blank">
              <IconButton className={styles.section_arrow} size="small">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          </Box>
        </div>
      </div>
    </div>
  );
}
